import React from "react";
import { Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useVersionCheckContext } from "../../contexts/VersionCheckContext";
import "./UpdateBanner.scss";

const UpdateBanner: React.FC = () => {
  const { hasUpdate, refreshApp } = useVersionCheckContext();

  if (!hasUpdate) return null;

  const handleRefresh = () => {
    refreshApp();
  };

  return (
    <div className="update-banner">
      <span className="update-banner-text">
        A new version is available
      </span>
      <Button
        type="primary"
        size="small"
        icon={<ReloadOutlined />}
        onClick={handleRefresh}
        className="update-banner-button"
      >
        Refresh
      </Button>
    </div>
  );
};

export default UpdateBanner;
